<template>
  <SmallSquare :content="content" :padding='true' />
  <a-card :bordered="false">
    <a-form ref='form' :model='search' :style="{'marginBottom':'20px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
      <a-form-item label="关键词" name='name'>
        <a-input style="width: 270px" v-model:value="search.name"  :placeholder="placeholder"/>
      </a-form-item>
      <a-form-item :label="type == 'dealer'?'级别':'类型/级别'" name='type' >
        <a-select v-model:value="search.level_id" style="width:180px" placeholder="请选择" v-if="type == 'dealer'">
          <a-select-option value="">全部</a-select-option>
          <a-select-option v-for='item in dealerLevelList' :key='item.level_id' :value="item.level_id">{{item.level_name}}
          </a-select-option>
        </a-select>
        <a-select v-model:value="search.type_id" style="width:180px;margin-right: 10px;" placeholder="请选择" v-if="type == 'store'">
          <a-select-option value="">全部</a-select-option>
          <a-select-option v-for='item in storeTypeList' :key='item.type_id' :value="item.type_id">{{item.type_name}}
          </a-select-option>
        </a-select>
        <a-select v-model:value="search.level_id" style="width:180px" placeholder="请选择" v-if="type == 'store'">
          <a-select-option value="">全部</a-select-option>
          <a-select-option v-for='item in storeLevelList' :key='item.id' :value="item.id">{{item.level_name}}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="状态" name='status' >
        <a-select v-model:value="search.status" :style="{width:'180px'}" placeholder="请选择">
          <a-select-option value="">全部状态</a-select-option>
          <a-select-option :value="1">正常</a-select-option>
          <a-select-option :value="0">禁用</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType='submit'>搜索</a-button>
      </a-form-item>
    </a-form>
    <a-table :pagination='false' :loading='listLoading' rowKey='id'  :columns='columns' :data-source='data' bordered :scroll="{ x: 'max-content'}" class='tableFixBox'>
      <template v-slot:status="{ record }">
        {{record.status ? '正常':'禁用'}}
      </template>
      <template v-slot:point="{ record }">
        <a v-has:dealerAssetsPonitLog="()=>{showPoint = true;id = record.store_id}"  href="javascript:;" >{{record.point}}</a>
      </template>
      <template v-slot:action="{ record }">
        <a-button v-has:dealerAssetsMore="()=> {$router.push('/assets/storeAssets/more?id='+record.store_id+'&type='+type+'&name='+record.name)}" class="m-r-10"> 查看明细</a-button>
        <a-button v-has:dealerAssetsManual="()=> {$router.push('/assets/storeAssets/add?id='+record.store_id+'&type='+type+'&name='+record.name)}"> 手动报销</a-button>
      </template>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
    <a-modal  :keyboard="false" centered v-model:visible="showPoint" :width='1300' :footer="null" destroyOnClose>
      <template #title>
        <span class="fz-16">积分账单</span><span class="p-l-10 fz-14 s_c999">显示成功报销信息，无效报销单和暂扣积分信息不显示</span>
      </template>
      <lookPoint :id='id'></lookPoint>
    </a-modal>
  
  </a-card>
</template>
<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { iscode } from "@/utils/app";
  import lookPoint from './lookPoint'
  import { getAssetsList } from '@/api/reimbursement';
  import { getPublicLevelList, getPublicTypeList } from "@/api/store";
  import { getDealerLevelList } from "@/api/dealer";
  // 初始化默认筛选项数值
  let defSearch = {
    name:'',
    status:'',
    level_id:'',
    type_id:'',
    page:1,
    limit:10
  }
  export default {
    components: {lookPoint},
    props:{
      content:String, //头部内容
      type:String, //类型，门店/经销商
      placeholder:String,//关键词提示语
      columns:Array, //表格头
    },
    setup(props) {
      const search = ref({ ...defSearch });
      const state = reactive({
        listLoading:false,
        showPoint:false,
        id:'',
        data:[],
        total:0,
        storeTypeList:[],
        storeLevelList:[],
        dealerLevelList:[]
      });
      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      // 获取门店类型列表
      const getStoreType = async () => {
        let res = await getPublicTypeList().then((res) => res.data);
        if (iscode(res)) {
          state.storeTypeList = res.data.data;
        } else {
          message.error(res.msg);
        }
      };
      //获取门店等级列表
      const getStoreLevel = async () => {
        let res = await getPublicLevelList().then((res) => res.data);
        if (iscode(res)) {
          state.storeLevelList = res.data.data;
        } else {
          message.error(res.msg);
        }
      };
      // 获取经销商等级
      const getDealerLevel = async () => {
        let res = await getDealerLevelList().then(res => res.data);
        if (iscode(res)) {
          state.dealerLevelList = res.data;
        } else {
          message.error(res.msg);
        }
      }
      const initData = async (values) => {
        state.listLoading = true;
        let res = await getAssetsList({...values,type:props.type == 'dealer' ? 2:1}).then(res => res.data).catch(error=>error);
        if (iscode(res)) {
          state.data = res.data.data;
          state.total = res.data.total;
        } else {
          message.error(res.msg);
        }
        state.listLoading = false;
      };
      onMounted(() => {
        if(props.type == 'dealer'){
          getDealerLevel()
        }else{
          getStoreType()
          getStoreLevel()
        }
        initData(search.value)
      });
      return {
        search,
        ...toRefs(state),
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        
      };
    },
  };
</script>